import { createSelector } from "@reduxjs/toolkit";
import { generatePath } from "react-router-dom";
import { RootState } from "@store/index";
import { DataRoomFund } from "@dataRoomSetup/models";
import { dataRoomsSelector } from "@dataRooms/store/selectors";
import { AppRoute } from "@app/models/AppRoute";

export const openDataRoomSetupDialogFlagSelector = (state: RootState): DataRoomFund["isOpenDataRoomDialog"] =>
  state.dataRoomSetup.isOpenDataRoomDialog;

export const isDataRoomEditable = (state: RootState): DataRoomFund["dataRoomEditable"] =>
  state.dataRoomSetup.dataRoomEditable;

export const dataRoomSetupSelector = createSelector(
  openDataRoomSetupDialogFlagSelector,
  (isOpenDataRoomSetupDialog) => ({
    isOpenDataRoomSetupDialog,
  })
);

export const dataRoomSetupFundSelector = createSelector(dataRoomsSelector, (funds) =>
  funds
    .map((fund) => ({
      label: fund.title,
      id: generatePath(AppRoute.DataRoom, { globalId: fund.globalId }),
    }))
    .sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1))
);
